/**
 * Get the available labels to populate the select list
 * @param state
 * @returns {[]|*[]}
 */
export const getAvailableLabels = (state) => state?.availableLabels || [];
/**
 * Get the array that will be send to the api
 * @param state
 * @returns {/* Vuex module state ['medias']
 */
export const getMediaLabels = (state) => state?.medias || [];
/**
 * Get the total number of tagged media
 * @param state
 * @returns {number}
 */
export const getTotal = (state) => state.total || 0;
/**
 * Get the status of the labels to know if we can submit to the API
 * @param state
 * @returns {boolean|*}
 */
export const labelsCanSubmit = (state) => state.canSubmitLabels;
